module.exports = __webpack_public_path__ + "img/shoppingcar.f9c6c7f5.svg";